import PlansManager from '../views/dashboard/Ajustes/Pagos/PlansManager'

const ChangePlanModal = ({ isOpen, onClose, onPlanUpdated, filterPlanBy }) => {
  return (
    <PlansManager
      isModal={true}
      isOpen={isOpen}
      onClose={onClose}
      onPlanUpdated={onPlanUpdated}
      showAddonsButton={true}
      filterPlanBy={filterPlanBy}
    />
  )
}

export default ChangePlanModal
